import React from 'react';
import PropTypes from 'prop-types';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import { Card, CardHeader } from 'common/Card';
import { usePopulate } from 'api/APIHooks';
import { AUTHORIZATION_STATUSES_TO_ICON, AUTHORIZATION_STATUSES_TO_COLOR } from 'common/Status/authorizationConstants';
import { FullWidthDetailList } from '../Layout';
import {
  AmountLineItem,
  BaseLineItem,
  ClinicalModificationsLineItem,
  NoteLineItem,
  ServiceDeliveryDatesLineItem,
} from '../LineItems';

const ServiceAuthorizationAcceptedCard = ({ authorization }) => {
  usePopulate(
    'fee_schedule_program',
    'fee_schedule_program',
    authorization,
    { queryConfig: { placeholderData: undefined } },
  );

  const authorizedAmount = authorization.approved_unit_amount || authorization.approved_cents;
  const isUnitBased = !fspUtils.isCostPaymentType(authorization.fee_schedule_program?.payment_type);
  const unit = authorization.fee_schedule_program?.unit;

  const cmCodeRequired = authorization.fee_schedule_program?.cm_code_required_on_authorization;

  return (
    <Card
      borderColor="border-green"
      className="px-2 py-2 bg-white"
      data-testid="auth-accepted-card"
    >
      <CardHeader
        className="pt-2 space-y-2"
        title="Authorization Details"
        titleIcon={AUTHORIZATION_STATUSES_TO_ICON.approved}
        iconColor={AUTHORIZATION_STATUSES_TO_COLOR.approved}
      />
      <FullWidthDetailList className="px-4 py-6">
        <AmountLineItem
          currentAmount={authorizedAmount}
          fieldName="Authorized Amount"
          isUnitBased={isUnitBased}
          unit={unit}
        />
        <ServiceDeliveryDatesLineItem
          fieldName="Authorized Service Delivery Date(s)"
          startDate={authorization.approved_starts_at}
          endDate={authorization.approved_ends_at}
        />
        {cmCodeRequired && (
          <ClinicalModificationsLineItem clinicalModifications={authorization.clinical_modifications} />
        )}
        <BaseLineItem field="Payer Authorization ID">
          {authorization.payer_authorization_number || 'N/A'}
        </BaseLineItem>
        {authorization.reviewer_note && (
          <NoteLineItem>
            {authorization.reviewer_note}
          </NoteLineItem>
        )}
      </FullWidthDetailList>
    </Card>
  );
};

ServiceAuthorizationAcceptedCard.propTypes = {
  authorization: PropTypes.object.isRequired,
};

export default ServiceAuthorizationAcceptedCard;
